<template>
    <div class="flex items-center mb-4 mt-2 flex-wrap justify-between">
        <h2 class="text-white text-sm sm:text-2xl font-semibold">{{ title }}</h2>
        <div class="flex items-center flex-wrap">
            <div class="flex items-center bg-gray-100 rounded-lg p-2 mr-4" v-if="localShow == true">
                <span class="font-bold text-sm sm:text-base">{{ titleItem }}: {{ localTotal }}</span>
            </div>
            <div class="flex items-center bg-gray-100 rounded-lg p-2 mr-4"
                v-if="localShow == true && localFromPage != 'agenda-marca'">
                <span class="font-bold text-sm sm:text-base">Mostrando: {{ localFrom }} - {{ localShowing }}</span>
            </div>
            <div class="flex items-center bg-gray-100 rounded-lg p-2 mr-4"
                v-if="localShow == true && localFromPage == 'agenda-marca'">
                <span class="font-bold text-sm sm:text-base">Marcas: {{ localMarcas }}</span>
            </div>

            <!-- Mini filtro de marcas -->
            <div class="relative mr-4" v-if="localFromPage == 'agenda-marca'">
                <div class="relative">
                    <input v-model="searchMarca" type="text" class="py-2 px-9 pr-9 bg-gray-100 rounded-lg w-64"
                        :placeholder="localModel ? ('Marca: ' + localModel) : 'Todas las marcas...'"
                        @focus="dropdownOpen = true" @keydown.down.prevent="moveDown" @keydown.up.prevent="moveUp"
                        @keydown.enter.prevent="selectHighlighted" @keydown.esc.prevent="dropdownOpen = false" />

                    <!-- Clear -->
                    <button v-if="searchMarca && searchMarca.length > 0" type="button"
                        class="absolute right-2 top-1/2 -translate-y-1/2 text-white hover:text-gray-900"
                        @mousedown.prevent @click="clearMarca" aria-label="Limpiar" title="Limpiar">
                        ✕
                    </button>
                </div>
                <div v-show="dropdownOpen"
                    class="absolute z-50 mt-1 w-full bg-white rounded-lg shadow-lg border border-gray-200 max-h-60 overflow-auto">
                    <div class="px-3 py-2 cursor-pointer hover:bg-gray-100 text-sm"
                        :class="highlightIndex === -1 ? 'bg-gray-100' : ''" @mousedown.prevent="selectMarca('')">
                        Todas las marcas
                    </div>

                    <div v-for="(category, idx) in filteredMarcas" :key="category.name"
                        class="px-3 py-2 cursor-pointer hover:bg-gray-100 text-sm"
                        :class="highlightIndex === idx ? 'bg-gray-100' : ''"
                        @mousedown.prevent="selectMarca(category.name)">
                        {{ category.name }}
                    </div>

                    <div v-if="filteredMarcas.length === 0" class="px-3 py-2 text-sm text-gray-500">
                        Sin resultados
                    </div>
                </div>

                <!-- Texto reflejado opcional (si quieres verlo SIEMPRE) -->
                <div class="text-white text-xs mt-1" v-if="localModel">
                    Filtrado por: <span class="font-semibold">{{ localModel }}</span>
                </div>
            </div>



            <div class="flex items-center bg-gray-100 rounded-lg p-2" @mouseenter="showText = true"
                @mouseleave="showText = false" role="button" @click="goBack">
                <span class="font-bold text-sm sm:text-base" v-show="!showText">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"
                        style="fill: rgba(0, 0, 0, 1);transform: ;msFilter:;">
                        <path d="M21 11H6.414l5.293-5.293-1.414-1.414L2.586 12l7.707 7.707 1.414-1.414L6.414 13H21z">
                        </path>
                    </svg>
                </span>
                <span class="font-bold text-sm sm:text-base" v-show="showText">Regresar</span>
            </div>

        </div>
    </div>
</template>
<script>
export default {
    name: "AppPageTitle",
    props: ['total', 'from', 'showing', 'titleItem', 'title', 'fromPage', 'marcas', 'model', 'data', 'showCounters'],
    computed: {
        filteredMarcas() {
            const q = (this.searchMarca || '').toLowerCase().trim();
            const list = this.localData || [];

            if (!q) {
                return list;
            }

            return list.filter(x => String(x.name || '').toLowerCase().includes(q));
        },
    },

    data() {
        return {
            showText: false,
            localModel: this.model,
            localShow: this.showCounters ?? true,
            localData: this.data ?? [],
            localMarcas: this.marcas ?? [],
            localShowing: this.showing ?? 0,
            localFrom: this.from ?? 0,
            localFromPage: this.fromPage ?? 0,
            localTotal: this.total ?? 0,
            nameConfig: 'Configuración de ' + this.from,
            searchMarca: '',
            dropdownOpen: false,
            highlightIndex: -1,
        }
    },
    watch: {
        data(newData) {
            this.localData = newData ?? [];
        },

        model(newModel) {
            this.localModel = newModel;
            this.searchMarca = newModel ? newModel : '';
        },
        marcas(newMarcas) {
            // Update the local marcas when the marcas prop changes
            this.localMarcas = newMarcas;
        },
        showing(newShowing) {
            // Update the local showing when the showing prop changes
            this.localShowing = newShowing;
        },
        from(newFrom) {
            // Update the local from when the from prop changes
            this.localFrom = newFrom;
        },
        fromPage(newFromPage) {
            // Update the local fromPage when the fromPage prop changes
            this.localFromPage = newFromPage;
        },
        total(newTotal) {
            // Update the local total when the total prop changes
            this.localTotal = newTotal;
        }
    },
    methods: {
        clearMarca() {
            this.searchMarca = '';
            this.highlightIndex = -1;
            this.dropdownOpen = true; // para que se vean todas al limpiar

            // Si quieres que limpiar también quite el filtro (todas):
            this.localModel = '';
            this.$emit('option-selected', '');
        },

        mouseenter() {
            this.showText = true;
        },
        mouseleave() {
            this.showText = false;
        },
        goBack() {
            // Use Vue Router to navigate back in the browser history
            if (window.history.length > 1) {
                this.$router.go(-1);
            } else {
                // If it is not possible to go back in the history, redirect to the home page
                this.$router.push('/inicio');
            }
        },
        onSelectChange(event) {
            // Emit an event with the selected value
            this.$emit('option-selected', event.target.value);
        },

        selectMarca(val) {
            this.localModel = val;                // '' => todas
            this.dropdownOpen = false;
            this.highlightIndex = -1;

            // Reflejar texto en input: si selecciona algo, mostramos el nombre; si no, limpiamos.
            this.searchMarca = val ? val : '';

            this.$emit('option-selected', val);
        },
        moveDown() {
            if (!this.dropdownOpen) {
                this.dropdownOpen = true;
            }

            // -1 es "todas las marcas", luego 0..n-1 son opciones
            const max = this.filteredMarcas.length - 1;
            if (this.highlightIndex < max) {
                this.highlightIndex++;
            }
        },

        moveUp() {
            if (this.highlightIndex > -1) {
                this.highlightIndex--;
            }
        },

        selectHighlighted() {
            // -1 = "todas"
            if (this.highlightIndex === -1) {
                this.selectMarca('');
                return;
            }

            const item = this.filteredMarcas[this.highlightIndex];
            if (item && item.name) {
                this.selectMarca(item.name);
            }
        }

    }
}
</script>
